import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { MDSTypography } from '@marqvision/mds-v2';
import { Desktop } from './responsive/Desktop';
import { TabletMobile } from './responsive/TabletMobile';

const useStyles = makeStyles((theme: Theme) => ({
  footer: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(5),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    bottom: 0,
    [theme.breakpoints.down(theme.breakpoint.tablet)]: {
      paddingBottom: 0,
    },
  },
  links: {
    display: 'flex',
    flexDirection: 'row',
    '& a': {
      ...theme.typography.regular,
      margin: '0 6px',
      fontSize: 12,
      color: theme.palette.snow8,
      '&:hover': {
        opacity: 0.7,
        textDecoration: 'none',
      },
    },
  },
  footerContent: {
    paddingTop: 5,
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
}));

const currentYear = new Date().getFullYear();

export const Footer = (): React.ReactNode => {
  const classes = useStyles();

  return (
    <div className={classes.footer}>
      <Desktop>
        <div className={classes.links}>
          <a href="https://www.marqvision.com" target="_blank" rel="noopener noreferrer">
            Home
          </a>
          <a href="https://www.marqvision.com/terms-2103" target="_blank" rel="noopener noreferrer">
            Terms
          </a>
          <a href="https://www.marqvision.com/privacy-policy" target="_blank" rel="noopener noreferrer">
            Privacy
          </a>
          <a href="mailto:contact@marqvision.com" rel="noopener noreferrer">
            Contact
          </a>
        </div>
        <MDSTypography variant="T14" color="color/content/neutral/secondary/normal" className={classes.footerContent}>
          © {currentYear} Marq Vision Inc. All Rights Reserved.
        </MDSTypography>
      </Desktop>
      <TabletMobile></TabletMobile>
    </div>
  );
};
